import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../common.type'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import { _MaskMaintainBase as MaskMaintainBase } from './cssVar/maskMaintainBase'
import { _MaskMaintainDefault as MaskMaintainDefault } from './cssVar/maskMaintainDefault'
import { _MaskMaintainSmall as MaskMaintainSmall } from './cssVar/maskMaintainSmall'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import Modal from '@/controller/Modal'
import style from './style.module.scss'
export { MaskMaintainBase, MaskMaintainDefault, MaskMaintainSmall }
export type MaskMaintainCssVarManager = GetCssVarManager<MaskMaintainBase>

/** 游戏维护层 */
@Component<MaskMaintain>({
  name: 'MaskMaintain'
})
export default class MaskMaintain extends Mixins<
  BaseCssVarInject<MaskMaintainBase>
>(Base, BaseCssVarInject) {
  /** 获得默认大小cssVar */
  public static getCssVarDefault = () => new MaskMaintainDefault()
  /** 获得小号cssVar */
  public static getCssVarSmall = () => new MaskMaintainSmall()
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>
  render() {
    const { t } = useI18n()
    const { isWeb } = useMainStore()
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      <div
        class={{
          [style['mask-maintain']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
        onClick={(event) => {
          event.stopPropagation()
          if (!isWeb) {
            Modal.message({
              type: 'warning',
              content: t('lobby.game.gameMaintainText')
            })
          }
        }}
      >
        <my-img
          options={{
            type: 'div',
            lazy: !isAtSwiper,
            immediate: isAtSwiper
          }}
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          class={[style['maintain-circle'], 'maintain-circle']}
          src={'/lobby_asset/{layout}-{bg}-common/common/common/img_dt_whz.png'}
        />
        <p
          class={{
            ['maintain-text']: true,
            [style['maintain-text']]: true
          }}
        >
          {t('lobby.game.maintain')}
        </p>
      </div>
    )
  }
}
